// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3DAW3","content":"GlobalSearch_content__2x5W5"};